import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SiteContentContext = createContext({
  blocks: {},
  chateaux: [],
  categories: [],
  categoriesBySlug: {},
  stays: [],
  settings: {},
  refresh: () => {},
});

export function SiteContentProvider({ children }) {
  const [blocks, setBlocks] = useState({});
  const [chateaux, setChateaux] = useState([]);
  const [categories, setCategories] = useState([]);
  const [stays, setStays] = useState([]);
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site-content");
      const map = {};
      (r.data.blocks || []).forEach((b) => { map[b.key] = b; });
      setBlocks(map);
      setChateaux(r.data.chateaux || []);
      setCategories(r.data.categories || []);
      setStays(r.data.stays || []);
      setSettings(r.data.settings || {});
    } catch {
      /* fallback silently */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const categoriesBySlug = React.useMemo(() => {
    const out = {};
    for (const c of categories) out[c.slug] = c;
    return out;
  }, [categories]);

  return (
    <SiteContentContext.Provider value={{ blocks, chateaux, categories, categoriesBySlug, stays, settings, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}

export function useBlock(key, lang, fallback = "") {
  const { blocks } = useSiteContent();
  const b = blocks[key];
  if (!b) return fallback;
  return b[lang] || b.fr || fallback;
}
